<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <el-form-item label="选择选品组">
                    <el-select v-model="xpz_value" placeholder="请选择" size="small" clearable >
                        <el-option v-for="item in xpz_options" :key="item.id" :label="item.favorites_title"
                            :value="item.favorites_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="begin">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-refresh" size="small" @click="handleSync">同步商品</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="item_id" label="商品ID" width="150"> </el-table-column>
                <el-table-column prop="pict_url" label="商品图" width="400">
                    <template slot-scope="scope">
                        <div class="u-f">
                            <div class="p_d1">
                                <img :src="scope.row.pict_url" alt="" width="80" height="80">
                            </div>
                            <div>
                                <div>{{scope.row.title}}</div>
                                <div>
                                    <div class="u-f">
                                        <div> <i class="el-icon-present reds"></i> 卷 {{scope.row.coupon_amount}}元 </div>
                                        <div> &nbsp;&nbsp; 共{{scope.row.coupon_remain_count}}张</div>
                                    </div>
                                    <div> <i class="el-icon-s-shop gray9"></i> <a target="_blank"
                                            :href="scope.row.click_url" class="gray9">{{scope.row.shop_title}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="pict_url" label="价格与销量" width="300">
                    <template slot-scope="scope">
                        <div class="u-f">
                            <div>
                                <div>￥{{scope.row.zk_final_price}}</div>
                                <div class="gray9 fs12">月销量：{{scope.row.volume}}元</div>

                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="commission_rate" label="收入比率">
                    <template slot-scope="scope">
                        <div>{{scope.row.commission_rate}}%</div>
                    </template>
                </el-table-column>
                <el-table-column prop="create_at" label="同步时间"> </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                xpz_value: '',
                xpz_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.getxpz()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios
                    .post("/admin/TbkCommodity/m_showlist", {
                        source: 'wxjg',
                        favorites_id: that.xpz_value,
                         page: that.currentPage,
                        page_count:that.pagesize
                    })
                    .then(response => {
                         that.loading = false
                        if (response.data.code == "200") {
                            that.count = response.data.data.total
                            that.tableData = response.data.data.list
                        } else {
                            that.$alert(response.data.msg)
                        }
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleSync() {
                let that = this
                var list = that.xpz_options.map(ele => ele.favorites_id)
                axios
                    .post("/admin/TbkCommodity/MSynchronousUpdateCommodity", {
                        source: 'wxjg',
                        author: this.user.id,
                        favorites_id: list.toString()
                    })
                    .then(response => {
                        if (response.data.code == "200") {
                            that.begin()
                            that.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: 'success'
                            });
                        } else {
                            that.$alert(response.data.msg)
                        }
                    })
                    .catch(error => {})
            },
            // 获取选品组下拉框
            getxpz(row) {
                let that = this
                axios
                    .post("/admin/TbkSelectionGroup/m_showlist", {
                        source: 'wxjg',
                    })
                    .then(response => {
                        that.xpz_options = response.data.data.list

                    })
                    .catch(error => {})
            },
        },

    };
</script>


<style scoped>
.p_d1{
    padding: 10px;
}

</style>